import { Pipe, PipeTransform } from '@angular/core';
import { NavLink } from '../models/navlink.model';

@Pipe({
  name: 'incNavShowPipe',
  pure: false
})
export class NavShowPipe implements PipeTransform {
  transform(items: NavLink[]): any {
    return items.filter(item =>
      !item.hidden);
  }
}
